<template>
  <div :class="avatarClass" aria-hidden="true">
    {{ initial }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const PALETTE_SIZE = 8;

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
});

const initial = computed(() => props.name.charAt(0).toUpperCase());

const colorIndex = computed(() => props.name.charCodeAt(0) % PALETTE_SIZE);

const avatarClass = computed(() => [
  'initial-avatar',
  `initial-avatar--color-${colorIndex.value}`,
]);
</script>

<style lang="scss" scoped>
.initial-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;

  &--color-0 { background-color: var(--sapphire-700); }
  &--color-1 { background-color: var(--teal-50); }
  &--color-2 { background-color: var(--coral-70); }
  &--color-3 { background-color: var(--honey-600); }
  &--color-4 { background-color: var(--tansy-50); }
  &--color-5 { background-color: var(--sapphire-900); }
  &--color-6 { background-color: var(--honey-700); }
  &--color-7 { background-color: var(--coral-40); }
}
</style>
